import React, { useState, useEffect, useRef } from 'react';
import ThoranVisual from './ThoranVisual';

const FlagSlideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const slideRef = useRef(null);
  const timeoutRef = useRef(null);

  // Enhanced photos collection with more details
  const mainPhotos = [
    {
      src: '/src/assets/Main photos/1.png',
      fallback: '/Main photos/Indian flag.jpg',
      title: 'Premium Indian National Flags',
      category: 'National Flags',
      description: 'High-quality Tiranga flags for Independence Day, Republic Day & patriotic celebrations',
      color: '#ff9933',
      gradient: 'linear-gradient(135deg, #ff9933, #ffffff, #138808)',
      features: ['Weather Resistant', 'Fade Proof', 'Hand Stitched']
    },
    {
      src: '/src/assets/Main photos/2.jpeg',
      fallback: '/Main photos/BJP flag.jpg',
      title: 'BJP Political Flags',
      category: 'Political Flags',
      description: 'Official Bharatiya Janata Party flags for rallies, campaigns & political events',
      color: '#ff6600',
      gradient: 'linear-gradient(135deg, #ff6600, #128807)',
      features: ['Official Design', 'Bulk Orders', 'Quick Delivery']
    },
    {
      src: '/src/assets/Main photos/3.jpeg',
      fallback: '/Main photos/congress flags.jpeg',
      title: 'Congress Party Flags',
      category: 'Political Flags',
      description: 'Indian National Congress flags with authentic colors and symbols',
      color: '#19aaed',
      gradient: 'linear-gradient(135deg, #19aaed, #ffffff)',
      features: ['Authentic Colors', 'Premium Quality', 'Custom Sizes']
    },
    {
      src: '/src/assets/Main photos/4.jpeg',
      fallback: '/Main photos/ganesh 1.jpeg',
      title: 'Ganesh Festival Flags',
      category: 'Festival Flags',
      description: 'Beautiful Lord Ganesh flags for Ganesh Chaturthi celebrations',
      color: '#ff6b35',
      gradient: 'linear-gradient(135deg, #ff6b35, #f7931e, #ffd700)',
      features: ['Festival Special', 'Vibrant Colors', 'Divine Designs']
    },
    {
      src: '/src/assets/Main photos/5.jpeg',
      fallback: '/Main photos/Hanuman flag1.jpeg',
      title: 'Hanuman Devotional Flags',
      category: 'Religious Flags',
      description: 'Sacred Hanuman flags for temples and religious ceremonies',
      color: '#ff4500',
      gradient: 'linear-gradient(135deg, #ff4500, #ff8c00)',
      features: ['Sacred Symbols', 'Temple Quality', 'Blessed Designs']
    },
    {
      src: '/src/assets/Main photos/6.jpeg',
      fallback: '/Main photos/tdp flags 1.jpeg',
      title: 'TDP Political Flags',
      category: 'Political Flags',
      description: 'Telugu Desam Party flags with vibrant colors and official designs',
      color: '#ffff00',
      gradient: 'linear-gradient(135deg, #ffff00, #ffd700)',
      features: ['Party Official', 'Durable Material', 'Campaign Ready']
    },
    {
      src: '/src/assets/Main photos/7.jpeg',
      fallback: '/Main photos/trs flags 1.jpeg',
      title: 'TRS Political Flags',
      category: 'Political Flags',
      description: 'Telangana Rashtra Samithi flags for state political events',
      color: '#ff1493',
      gradient: 'linear-gradient(135deg, #ff1493, #ff69b4)',
      features: ['State Pride', 'Quality Print', 'Event Ready']
    },
    {
      src: '/src/assets/Main photos/8.jpeg',
      fallback: '/Main photos/Indian flag2.jpg',
      title: 'Large Format National Flags',
      category: 'National Flags',
      description: 'Extra large Indian flags perfect for buildings and major events',
      color: '#138808',
      gradient: 'linear-gradient(135deg, #ff9933, #ffffff, #138808)',
      features: ['Extra Large', 'Building Grade', 'Wind Resistant']
    },
    {
      src: '/src/assets/Main photos/9.jpeg',
      fallback: '/Main photos/ganesh2.jpeg',
      title: 'Colorful Festival Banners',
      category: 'Festival Flags',
      description: 'Vibrant festival flags and banners for all occasions',
      color: '#8a2be2',
      gradient: 'linear-gradient(135deg, #8a2be2, #da70d6, #ff69b4)',
      features: ['Multi-Color', 'Festival Special', 'Eye Catching']
    },
    {
      src: '/src/assets/Main photos/10.jpeg',
      fallback: '/Main photos/Srirama navami flags.jpeg',
      title: 'Sri Rama Navami Flags',
      category: 'Religious Flags',
      description: 'Special flags for Lord Rama festivals and celebrations',
      color: '#ffd700',
      gradient: 'linear-gradient(135deg, #ffd700, #ffa500)',
      features: ['Religious Festival', 'Premium Finish', 'Spiritual Design']
    },
    {
      src: '/Main photos/thoran-event.jpg',
      fallback: null,
      isThoranSlide: false,
      title: 'Large Scale Thoran Decoration',
      category: 'Buntings & Thorans',
      description: 'Massive saffron thoran installation covering an entire roundabout. We supply bulk thorans for large-scale events, rallies and city decorations.',
      color: '#FF6600',
      gradient: 'linear-gradient(135deg, #FF6600, #FF9933, #FFB347)',
      features: ['Large Scale Supply', 'Bulk Wholesale', 'Event Ready']
    },
    {
      src: null,
      isThoranSlide: true,
      thoranColors: ['#FF9933','#FFFFFF','#138808','#FF9933','#FFFFFF','#138808'],
      bgColor: '#F0F8FF',
      title: 'Tricolor Thoran – National Special',
      category: 'Buntings & Thorans',
      description: 'Saffron, White & Green buntings for Independence Day, Republic Day and patriotic events. Bulk orders available.',
      color: '#138808',
      gradient: 'linear-gradient(135deg, #FF9933, #ffffff, #138808)',
      features: ['National Colours', 'Cotton Fabric', 'Bulk Orders']
    },
    {
      src: null,
      isThoranSlide: true,
      thoranColors: ['#FF9933','#FF9933','#FF9933','#FF9933','#FF9933','#FF9933'],
      bgColor: '#FFF3E0',
      title: 'Kesari Saffron Thoran',
      category: 'Buntings & Thorans',
      description: 'Premium saffron bunting for religious events, rally processions, programmes and pandal decorations.',
      color: '#FF9933',
      gradient: 'linear-gradient(135deg, #FF9933, #FF6600)',
      features: ['Religious Events', 'Reusable & Washable', 'Wholesale Rates']
    },
    {
      src: null,
      isThoranSlide: true,
      thoranColors: ['#FF4444','#FF9933','#FDD835','#28A745','#1565C0','#9B59B6'],
      bgColor: '#F8F0FF',
      title: 'Multicolor Rainbow Thoran',
      category: 'Buntings & Thorans',
      description: 'Vibrant multicolor bunting for all festivals, weddings, cultural events and pandals. Every colour in one string!',
      color: '#9B59B6',
      gradient: 'linear-gradient(135deg, #FF4444, #FF9933, #FDD835, #28A745, #1565C0, #9B59B6)',
      features: ['All Colours', 'All Occasions', 'Bulk Orders']
    }
  ];

  const totalSlides = mainPhotos.length;

  // Enhanced auto-play with smooth transitions
  useEffect(() => {
    if (!isAutoPlay || isTransitioning) return;

    const interval = setInterval(() => {
      handleSlideTransition('next');
    }, 2500);

    return () => clearInterval(interval);
  }, [isAutoPlay, isTransitioning, currentSlide]);

  // Smooth transition handler
  const handleSlideTransition = (direction) => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    
    if (direction === 'next') {
      setCurrentSlide(prev => (prev + 1) % totalSlides);
    } else if (direction === 'prev') {
      setCurrentSlide(prev => (prev - 1 + totalSlides) % totalSlides);
    }

    // Reset transition state
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIsTransitioning(false);
    }, 350);
  };

  // Enhanced touch handlers with momentum
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      handleSlideTransition('next');
    } else if (isRightSwipe) {
      handleSlideTransition('prev');
    }
  };

  // Navigation functions
  const nextSlide = () => handleSlideTransition('next');
  const prevSlide = () => handleSlideTransition('prev');

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIsTransitioning(false);
    }, 350);
  };

  // Enhanced image error handling with retry
  const handleImageError = (e) => {
    const img = e.target;
    const slideIndex = parseInt(img.dataset.slideIndex);
    const slideData = mainPhotos[slideIndex];
    
    if (slideData && slideData.fallback && img.src !== slideData.fallback) {
      img.src = slideData.fallback;
    }
  };

  // Enhanced loading with progress
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  if (isLoading) {
    return (
      <div className="pro-slideshow-container">
        <div className="loading-screen">
          <div className="loading-content">
            <div className="loading-spinner"></div>
            <h3 className="loading-title">Loading Premium Flag Collection</h3>
            <p className="loading-subtitle">Preparing the finest flags for you...</p>
            <div className="loading-progress">
              <div className="progress-bar"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const currentPhoto = mainPhotos[currentSlide];
  const prevPhoto = mainPhotos[(currentSlide - 1 + totalSlides) % totalSlides];
  const nextPhoto = mainPhotos[(currentSlide + 1) % totalSlides];

  return (
    <div className="pro-slideshow-container" style={{'--current-gradient': currentPhoto.gradient}}>
      
      {/* Background Elements */}
      <div className="slideshow-background">
        <div className="bg-gradient-primary"></div>
        <div className="bg-pattern"></div>
        <div className="bg-particles"></div>
      </div>

      <div className="pro-slideshow">
        
        {/* Enhanced Header */}
        <div className="slideshow-header-pro">
          <div className="header-content">
            <h1 className="main-title">
              <span className="title-icon">🇮🇳</span>
              <span className="title-text">SR Indian Flags</span>
              <span className="title-subtitle">Premium Collection</span>
            </h1>
            <p className="header-description">
              Crafted with Pride • Made in India • Premium Quality Guaranteed
            </p>
            
            {/* Control Panel */}
            <div className="control-panel">
              <div className="playback-controls">
                <button
                  className={`control-btn ${isAutoPlay ? 'active' : ''}`}
                  onClick={() => setIsAutoPlay(!isAutoPlay)}
                  aria-label={isAutoPlay ? 'Pause slideshow' : 'Play slideshow'}
                >
                  <i className={`bi ${isAutoPlay ? 'bi-pause-fill' : 'bi-play-fill'}`}></i>
                </button>
                <span className="slide-info">{currentSlide + 1} / {totalSlides}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Slideshow Area */}
        <div
          className="slideshow-main-area"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          ref={slideRef}
        >
          
          {/* Current Slide - Center Focus */}
          <div className={`main-slide ${isTransitioning ? 'transitioning' : ''}`}>
            <div className="slide-container">
              <div className="image-wrapper">
                <div className="image-frame" style={{'--slide-color': currentPhoto.color}}>
                  {currentPhoto.isThoranSlide ? (
                    <ThoranVisual
                      thoranColors={currentPhoto.thoranColors}
                      bgColor={currentPhoto.bgColor}
                      height={380}
                    />
                  ) : (
                  <img
                    src={currentPhoto.src}
                    alt={currentPhoto.title}
                    className="slide-image"
                    data-slide-index={currentSlide}
                    onError={handleImageError}
                    loading="eager"
                  />
                  )}
                  <div className="image-overlay">
                    <div className="rolling-light"></div>
                    <div className="shimmer-effect"></div>
                  </div>
                </div>
                
                {/* Floating Info Card */}
                <div className="info-card glass-morphism">
                  <div className="card-header">
                    <h2 className="slide-title">{currentPhoto.title}</h2>
                    <span className="category-badge" style={{'--badge-color': currentPhoto.color}}>
                      {currentPhoto.category}
                    </span>
                  </div>
                  
                  <p className="slide-description">{currentPhoto.description}</p>
                  
                  <div className="features-list">
                    {currentPhoto.features.map((feature, idx) => (
                      <span key={idx} className="feature-tag">
                        <i className="bi bi-check-circle-fill"></i>
                        {feature}
                      </span>
                    ))}
                  </div>
                  
                  <div className="action-buttons">
                    <a
                      href={`/flags/${currentPhoto.category.toLowerCase().replace(' ', '-')}`}
                      className="btn btn-primary-pro"
                      style={{'--btn-color': currentPhoto.color}}
                    >
                      <i className="bi bi-eye"></i>
                      View Collection
                    </a>
                    <a
                      href="https://wa.me/919700388626"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success-pro"
                    >
                      <i className="bi bi-whatsapp"></i>
                      Order Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Side Previews */}
          <div className="side-previews">
            {/* Previous Preview */}
            <div
              className="preview-slide prev-preview"
              onClick={prevSlide}
              role="button"
              aria-label="Previous slide"
            >
              <div className="preview-image">
                <img
                  src={prevPhoto.src}
                  alt={prevPhoto.title}
                  data-slide-index={(currentSlide - 1 + totalSlides) % totalSlides}
                  onError={handleImageError}
                  loading="lazy"
                />
                <div className="preview-overlay">
                  <i className="bi bi-chevron-left"></i>
                </div>
              </div>
            </div>

            {/* Next Preview */}
            <div
              className="preview-slide next-preview"
              onClick={nextSlide}
              role="button"
              aria-label="Next slide"
            >
              <div className="preview-image">
                <img
                  src={nextPhoto.src}
                  alt={nextPhoto.title}
                  data-slide-index={(currentSlide + 1) % totalSlides}
                  onError={handleImageError}
                  loading="lazy"
                />
                <div className="preview-overlay">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="nav-controls">
            <button
              className="nav-btn prev-btn"
              onClick={prevSlide}
              disabled={isTransitioning}
              aria-label="Previous slide"
            >
              <i className="bi bi-chevron-left"></i>
            </button>
            <button
              className="nav-btn next-btn"
              onClick={nextSlide}
              disabled={isTransitioning}
              aria-label="Next slide"
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="indicators-container">
          <div className="indicators">
            {mainPhotos.map((photo, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                style={{'--indicator-color': photo.color}}
                aria-label={`Go to slide ${index + 1}: ${photo.title}`}
              >
                <span className="indicator-progress"></span>
              </button>
            ))}
          </div>
        </div>

        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-track">
            <div
              className="progress-fill"
              style={{
                width: `${((currentSlide + 1) / totalSlides) * 100}%`,
                background: currentPhoto.gradient,
                animation: isAutoPlay ? 'progress-advance 2.5s linear infinite' : 'none'
              }}
            ></div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="slideshow-footer">
          <div className="contact-section glass-morphism">
            <div className="contact-content">
              <div className="contact-info">
                <h4>Ready to Order Premium Flags?</h4>
                <p>Get instant quotes for bulk orders • Custom designs available • Fast delivery across India</p>
              </div>
              <div className="contact-actions">
                <a href="tel:9700388626" className="contact-btn phone-btn">
                  <i className="bi bi-telephone-fill"></i>
                  <span>Call Now</span>
                  <small>9700388626</small>
                </a>
                <a
                  href="https://wa.me/919700388626"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-btn whatsapp-btn"
                >
                  <i className="bi bi-whatsapp"></i>
                  <span>WhatsApp</span>
                  <small>Quick Response</small>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FlagSlideshow;